import React, { Component } from 'react'
import { connect } from 'react-redux'
import AsideStyle from '../styles/AsideStyle'
import Menu from '../components/Menu'
import FileInfo from '../components/FileInfo'
import NaglowekSprawozdania from './NaglowekSprawozdania'

class Aside extends Component {
  render() {
    const { menu, fileInfo, OkresOd, OkresDo, KodSprawozdania } = this.props
    return (
      <AsideStyle>
        <NaglowekSprawozdania
          OkresOd={OkresOd}
          OkresDo={OkresDo}
          KodSprawozdania={KodSprawozdania}
        />
        <Menu menu={menu} />
        <FileInfo fileInfo={fileInfo} />
      </AsideStyle>
    )
  }
}

const mapStateToProps = state => {
  return {
    menu: state.sprawozdanie.header.Menu,
    fileInfo: {
      name: state.sprawozdanie.fileName,
      code: state.sprawozdanie.header.KodSystemowy,
      version: state.sprawozdanie.header.WersjaSchemy,
    },
    OkresOd: state.sprawozdanie.dateFrom,
    OkresDo: state.sprawozdanie.dateTo,
    KodSprawozdania: state.sprawozdanie.header.KodSprawozdania,
  }
}

export default connect(mapStateToProps)(Aside)
